import { DEFAULT_USER_DATA } from "@/constants/defaults"
import { TLoginUserData } from "@/schemas/user.schema"
import { create } from "zustand"
import { persistNSync } from "persist-and-sync"
import { persist } from "zustand/middleware"

interface TAppStore {
  isSidebarMenuExpanded: boolean
  userData: TLoginUserData & { xAuth: string }
  _old_webphone: boolean
  webphoneSelectedContactID?: string
  webphoneExpanded: boolean
  webphonePoppedOut: boolean
  webphonePopup: {
    height: number
    width: number
  }
}

interface TAppStoreWithFunctions extends TAppStore {
  changeSidebarMenuState: (setExpanded: boolean) => void
  setUserData: (userData: TLoginUserData & { xAuth: string }) => void
  setWebphoneExpanded: (expanded: boolean) => void
  setWebphonePoppedOut: (poppedOut: boolean) => void
  setWebphonePopupSize: ({
    width,
    height,
  }: {
    width: number
    height: number
  }) => void
  // changeWebphonePopupTmp: (tmp: boolean) => void
  changeWebphonePopupOld: (old: boolean) => void
  changeSelectedContactID: (contactID?: string) => void
}

const initialState: TAppStore = {
  isSidebarMenuExpanded: false,
  userData: {
    ...DEFAULT_USER_DATA,
    xAuth: "",
  },
  _old_webphone: false,
  webphoneExpanded: true,
  webphonePoppedOut: false,
  webphonePopup: {
    height: 600,
    width: 420,
  },
}

export const useAppStore = create<TAppStoreWithFunctions>()(
  persist(
    (set) => ({
      ...initialState,
      changeSidebarMenuState: (setExpanded) =>
        set(() => ({ isSidebarMenuExpanded: setExpanded })),
      setUserData: (userData) => set(() => ({ userData })),
      setWebphoneExpanded: (expanded) =>
        set(() => ({ webphoneExpanded: expanded })),
      setWebphonePoppedOut: (poppedOut) =>
        set(() => ({ webphonePoppedOut: poppedOut })),
      setWebphonePopupSize: ({ width, height }) =>
        set(() => ({ webphonePopup: { width, height } })),
      // changeWebphonePopupTmp: (tmp) => set(() => ({ _old_webphone: tmp })),
      changeWebphonePopupOld: (old) =>
        set(() => {
          return {
            _old_webphone: old,
          }
        }),
      changeSelectedContactID: (contactID) =>
        set(() => ({ webphoneSelectedContactID: contactID })),
    }),
    {
      name: "appstore-channel",
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) => !["_old_webphone", "webphoneExpanded"].includes(key)
          )
        ),
    }
  )
)
